export default __webpack_public_path__ + "static/media/led2_down_overlay.9ea2aeff.svg";